import { REFETCH_ASSOCIATIONS } from './constants';
class AssetPreviewObserver {
  constructor() {
    this.observers = {};
  }
  on(event, observer) {
    if (!this.observers[event]) {
      this.observers[event] = [];
    }
    this.observers[event].push(observer);
  }
  off(event, observer) {
    if (!this.observers[event]) {
      return;
    }
    this.observers[event] = this.observers[event].filter(ob => ob !== observer);
  }
  notify(event, ...args) {
    if (this.observers[event]) {
      this.observers[event].forEach(observer => observer(...args));
    }

    /**
     * Notifies all events when subscribed to '*'
     */
    if (this.observers['*']) {
      this.observers['*'].forEach(observer => observer(event, ...args));
    }
  }
  refetchAssociations() {
    this.notify(REFETCH_ASSOCIATIONS);
  }
}
const assetPreviewObserver = new AssetPreviewObserver();
export default assetPreviewObserver;